import React from 'react';
import { CheckCircle } from 'lucide-react';

const GRUENDE = [
  'Fahrzeug nicht fahrbereit',
  'Schaden soll sauber dokumentiert werden',
  'Zeit sparen',
  'Klare Beweissicherung'
];

export const WannVorOrt = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Vorteile
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Wann eine Vor-Ort-Begutachtung sinnvoll ist
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {GRUENDE.map((grund, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-2xl p-6 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-brand-green/10 rounded-xl flex items-center justify-center border border-brand-green/15">
                    <CheckCircle className="w-5 h-5 text-brand-green" />
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed text-[15px] pt-1.5">{grund}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};